import { render, staticRenderFns } from "./final.vue?vue&type=template&id=06b0e71b&scoped=true&"
import script from "./final.vue?vue&type=script&lang=ts&"
export * from "./final.vue?vue&type=script&lang=ts&"
import style0 from "./final.vue?vue&type=style&index=0&id=06b0e71b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b0e71b",
  null
  
)

export default component.exports